export const BasicInfoUrl = {
  // Province
  // get all
  GetAllProvince: '/PreReserve/ProvinceQuery/GetAllProvinces',
  // get province cities
  GetProviceCities: '/PreReserve/ProvinceQuery/GetCitiesByProvinceId',
  // get by id
  GetProvinceById: '/PreReserve/ProvinceQuery/GetProvinceById',
  // create
  CreateProvince: '/PreReserve/ProvinceCommand/CreateProvince',
  // update
  UpdateProvince: '/PreReserve/ProvinceCommand/UpdateProvince',
}
